<template>
  <a-modal v-model:visible="visible" width="550px" :maskClosable="false" :closable="true" @cancel="close">
    <template #title>
      <a-space style="line-height: 1">
        <InfoCircleOutlined style="color: #0068ff; font-size: 20px; line-height: 1" />
        <span>温馨提示</span>
      </a-space>
    </template>
    <div style="font-size: 15px" v-html="getMsg" />
    <template #footer>
      <template v-if="type === 1">
        <a-button @click="gotoMall">更换1688授权</a-button>
        <a-button
          @click="
            gotoUrl(
              'https://ufuwu.1688.com/page/fuwu_work_isv_container.htm?appkey=6887888&spm=a26370.20994420.fwsj_work_bench.17.b96961ceWKWBJN'
            )
          "
          >解绑1688店铺授权</a-button
        >
        <a-button
          @click="
            gotoUrl(
              'https://pc.1688.com/product/detail.htm?spm=a26370.20994420.fwsj_work_bench.15.b96961ceWKWBJN&productCode=jkYqs7oed4TmA3goc4hn4tzMgB59q%2F2Qxy8dVryVP6o%3D&productType=GROUP'
            )
          "
          type="primary"
          >前往订购付费版</a-button
        >
      </template>
      <template v-else>
        <a-button @click="visible = false">取消</a-button>
        <a-button @click="close2" type="primary">确定</a-button>
      </template>
    </template>
  </a-modal>
</template>
<script>
import { InfoCircleOutlined } from "@ant-design/icons-vue";
export default {
  components: { InfoCircleOutlined },
  data() {
    return {
      visible: false,
      item: {},
      type: 1,
      resolve: null,
    };
  },
  methods: {
    open(item) {
      this.type = 1;
      this.visible = true;
      this.item = item;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    gotoMall() {
      this.$router.push({ path: "/home/mallGroup" });
    },
    close() {
      this.visible = false;
    },
    gotoUrl(url) {
      window.open(url);
      this.type = 2; // 因为还要二次确认是否操作好了，所以type设置为2
    },
    close2() {
      this.resolve();
      this.visible = false;
    },
  },
  computed: {
    getMsg() {
      return this.type !== 1 ? "如已确认操作完成，请点击【确定】按钮" : this.item.msg;
    },
  },
};
</script>
